import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getFilesRequest } from "lib/api/reference/file";
import type { FileInterface } from "types/reference";

export const fileReferenceKeys = {
    all: ["reference", "file"] as const,
    list: (languageCode: string) => [...fileReferenceKeys.all, "list", languageCode] as const,
};

export const fetchFiles = (languageCode: string) => parseResponse<Array<FileInterface>>(getFilesRequest(languageCode));

export const fileReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<FileInterface>>({
        queryKey: fileReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchFiles(languageCode),
        enabled: Boolean(languageCode),
    });

export const useFiles = (languageCode: string) => useQuery(fileReferenceQueryOptions(languageCode));
